import React from 'react';
import Modal from 'react-modal';
import {connect} from "react-redux";
import moment from 'moment';
import PropTypes from 'prop-types';

import {NotificationManager} from "react-notifications";

import * as AdminActions from "../../../../actions/admin"
import config from "../../../../../../server/src/config";

class StartSeasonDialog extends React.Component {

    static propTypes = {
        onClose: PropTypes.func.isRequired,
        onSuccess: PropTypes.func,
    };

    static defaultProps = {
        onSuccess: null,
    };

    constructor(props) {
        super(props);
        this.state = {
            deleteRaces: null,
        }
    }

    render() {
        const fileExtentions = [...Array(100).keys()].map(i => '.' + String(i).padStart(2, '0'));
        return <div>
            <Modal
                isOpen={true}
                onRequestClose={() => {this.props.onClose()}}
                style={{
                    overlay: {
                        zIndex: 10,
                    },
                    content : {
                        height: this.props.auth.database === 'standard' ? '340px' : '425px',
                        width: '500px',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    }
                }}
            >
                <div className="dialog">
                    <div className="dialog-title">Ny sæson</div>

                    <div className="dialog-body">
                        <div className="dialog-inner-body">
                            <div className="small-vertical-spacing">
                                <input type="radio" id="deleteRaces" name="raceDeleteOption" checked={this.state.deleteRaces === true} onClick={() => this.setState({deleteRaces: true})}/> <label htmlFor="deleteRaces">Slet alle kapflyvninger</label>
                            </div>
                            <div className="small-vertical-spacing">
                                <input type="radio" id="retainRaces" name="raceDeleteOption" checked={this.state.deleteRaces === false} onClick={() => this.setState({deleteRaces: false})}/> <label htmlFor="retainRaces">Bibehold kapflyvninger, men nulstil sliptider og præmier</label>
                            </div>
                            <div className="info">
                                <p>Ved sæsonstart nulstilles/slettes en række data såsom sliptider, kapflyvningsresultater, mesterskabsresultater og fejllister.</p>
                                <p>Det kan anbefales at <b>tage en backup</b> af databasen, inden den nye sæson startes, og data nulstilles. En sådan backup vil endvidere kunne indlæses til en arkivdatabase ved indlæsning af backup'en med angivelse af et årstal.</p>
                                {this.props.auth.database === 'standard' ? null : <p className="warning-information">
                                    Du har i øjeblikket åbnet en arkivdatabase. Hvis du starter en ny sæson nu, vil du nulstille <b>arkivdatabasen</b>. For at starte en ny sæson i den primære database, skal du først returnere til standarddatabasen.
                                </p>}
                            </div>
                        </div>
                    </div>

                    <div className="actions-row">
                        <button className="btn-dangerous" disabled={this.state.deleteRaces === null} onClick={this.onStartSeason} title="Nulstiller en række data ved sæsonstart. Det anbefales at sikre, at en databasebackup er tilgængelig, inden den nye sæson startes.">Nulstil data</button>
                        <button className="btn-primary float-right" onClick={() => {this.props.onClose()}}>Annuller</button>
                    </div>
                </div>
            </Modal>
        </div>
    }

    onStartSeason = () => {
        if (this.state.deleteRaces !== null) this.props.dispatch(AdminActions.startSeason({
            deleteRaces: this.state.deleteRaces
        }, () => {
            NotificationManager.success('Alle resultater er nu slettet, og en ny sæson er påbegyndt.', 'Sæsonstart', 4000);
            this.props.onClose();
        }))
    };
}

const mapStateToProps = (state) => ({
    auth: {
        database: state.auth.database,
    },
});

export default connect(mapStateToProps)(StartSeasonDialog);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/home/dialogs/StartSeasonDialog.js